import React from 'react';
import { Layout } from 'react-admin';
import CustomAppBar from "./customAppBar";
import Menu from "./customSideMenu";

const CustomLayout = props => <Layout {...props} appBar={CustomAppBar} menu={Menu}/>;

export default CustomLayout;
